import { HttpClient } from "@angular/common/http";
import {Component,ElementRef,OnInit, ViewChild} from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import * as moment from "moment";
import { Subject } from "rxjs";
import { EncryptionService } from "src/app/_services/encryption.service";
import { ExcelService } from "src/app/_services/excel.service";
import { MentorshipDashboardService } from "src/app/_services/mentorship-dashboard.service";

declare const $: any;

class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Component({
    selector: 'app-most-searched-mentors',
    templateUrl: './most-searched-mentors.component.html'
})


export class MostSearchedMentorsComponent implements OnInit{
  @ViewChild("datePicker", { static: false }) datePicker: ElementRef;
  filterData = { status: "" };
  startDate :any
  endDate :any
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  // dtOptions: DataTables.Settings = {};
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [4], orderable: false }],
  }
  exportSmartMatchList: any = [];
  fieldsToIncludeExcel: any = [];
  exl: boolean = false;

  dtTrigger = new Subject();
  mostSearchMentorsArr: any = []; // Table Data list
  totalSmartMatch: any;
  modalReference: NgbActiveModal;
  modalCropper: NgbActiveModal;
  showloding = true;
  lodingImage = false;
  isSubmitted = false;
  dateInvalid: boolean = false;
  today: string = '';

  constructor(
    public router: Router,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private dataService: MentorshipDashboardService,
    private excelService: ExcelService,
  ) {
    const now = new Date();
    this.today = now.toISOString().split('T')[0];
  }

 
ngOnInit() {
        window.scroll(0, 0);
        const strtDate = sessionStorage.getItem('startDate');
        const endDate = sessionStorage.getItem('endDate');
        this.startDate = strtDate ;
        this.endDate = endDate;
        this.getListing() 
        this.mostSearchedMentors()
  }


 getListing() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      order: [[3, 'desc']],
      ajax: (dataTablesParameters: any, callback) => {
        const data = {
          "type" : 'most_searched_mentors',
          "export": false,
          "start_date":this.startDate,
          "end_date": this.endDate,
           "top": this.filterData.status,
          }

        const requestPayload = {
          ...dataTablesParameters,
          ...data, 
        };
  
        const encryptedData = this.enc_dec.encrypt(JSON.stringify(requestPayload));
  
        this.http
          .post<DataTablesResponse>(
            '/api/metric-list',
            { req_data: encryptedData },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);
  
            this.mostSearchMentorsArr = resp['data'];
            this.totalSmartMatch = resp['recordsTotal'];

            callback({
              recordsTotal: resp['recordsTotal'],
              recordsFiltered: resp['recordsFiltered'],
              data: [], 
            });
          });
        },

      columns: [
          { data: 'id' },
          { data: 'mentor_name' },
          { data: 'search_count' },
          { data: 'last_visited_at' }, 
      ],
    };
 }


 
 ngAfterViewInit(): void {
    this.dtTrigger.next();
    $('#searched_mentors').on('page.dt', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

   ngOnDestroy(): void {
     $('#searched_mentors').off('page.dt');
    this.dtTrigger.unsubscribe();
  }
 
   
      blockTyping(event: KeyboardEvent) {
        event.preventDefault();  // This will prevent typing
      }



   onReset() {
       this.isSubmitted = false;
       this.startDate = ''
       this.endDate = ''
       this.filterData.status = ''
       sessionStorage.removeItem('startDate');
       sessionStorage.removeItem('endDate');
       const table = $("#searched_mentors").DataTable();
       table.ajax.reload(null, false);
       this.mostSearchedMentors()
   }


   onSearch() {
    this.isSubmitted = true;
    this.dateInvalid = false;
  
    if (!this.startDate || !this.endDate) {
      return;
    }
  
    const start = new Date(this.startDate);
    const end = new Date(this.endDate);
  
    if (start > end) {
      this.dateInvalid = true;
      return;
    }
    const table = $("#searched_mentors").DataTable();
    table.ajax.reload(null, false);
    this.mostSearchedMentors()
  
  } 

 mostSearchedMentors() {
 
   const data =  {
    "draw": 1,
    "start": 0,
    "length": 1,
    "order": [
        {
            "column": 3,
            "dir": "desc"
        }
    ],
    "search": {
        "value": "",
        "regex": false
    },
    "start_date":this.startDate,
    "end_date": this.endDate,
    "export": true,
    "type": "most_searched_mentors",
    "top": this.filterData.status,

  }

  this.loadShow();
  this.dataService
    .dataExport(data)
    .pipe()
    .subscribe((res) => {
        this.exportSmartMatchList = res["data"];

        this.fieldsToIncludeExcel = [
          "mentor_name",
          "search_count",
          "last_visited_at"
       
        ];

        this.exl = true;
      this.loadHide();
    });
  }

   setFilterData(e: any) {
    this.filterData.status = e.target.value;
    // this.getListing()
    this.mostSearchedMentors()
    const table = $("#searched_mentors").DataTable();
    table.search('').draw();
    table.ajax.reload(null, false);
  }


exportToExcel() {
  this.excelService.generateExcel(
    this.exportSmartMatchList,
    this.fieldsToIncludeExcel,
    "Mentorship Most Searched Mentors"
  );
}
  

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }


  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
